import { Form } from 'antd';

import { useHotels } from 'app/hooks/data/hotels/useHotel';
import type { OpeningHours } from 'app/typings/core/admin/packs/openingHours/openingHours';
import type { PackResponse } from 'app/typings/core/admin/packs/pack';

import './General.scss';
import { BasicInformations } from './_components/BasicInformations';
import { Naming } from './_components/Naming';
import { OpeningHoursComponent } from './_components/OpeningHours';

export const General = () => {
  const form = Form.useFormInstance<
    Partial<PackResponse> & {
      isDaytime: boolean;
      aliasForUser: string;
      openingHours: OpeningHours;
    }
  >();
  const formValues = Form.useWatch([], form);
  const { data: hotels } = useHotels();

  if (!hotels) {
    return null;
  }

  const showNamingCard = !!formValues?.hotelId;
  const showOpeningHours = formValues?.isDaytime;

  return (
    <>
      <BasicInformations />
      {showNamingCard && <Naming />}
      {showOpeningHours && <OpeningHoursComponent />}
    </>
  );
};
